import { fetchAndSaveFullUser, parseAuthHash } from '../ui/auth';
import { renderUserBox } from '../app';
import { clearSession } from '../state';
import { navigateTo } from '../router';

// При переходе по ссылке подтверждения email Supabase редиректит сюда
// с токенами в hash (#access_token=...&refresh_token=...&type=signup).
// Сразу превращаем их в активную сессию — автологин после активации профиля.
export function mountConfirmEmail(): void {
  const { accessToken, refreshToken } = parseAuthHash();

  // Ссылка без токена (устарела/битая) — просто отправляем на форму входа.
  if (!accessToken) {
    navigateTo('/auth', true);
    return;
  }

  void (async () => {
    // Чистим прежнюю сессию, чтобы не смешать аккаунты.
    clearSession();

    const user = await fetchAndSaveFullUser(accessToken, refreshToken ?? undefined);
    if (user) {
      renderUserBox();
      navigateTo('/', true);
    } else {
      // Токен не сработал — пусть подтвердит вход вручную.
      navigateTo('/auth', true);
    }
  })();
}

export function unmountConfirmEmail(): void {}
